import { Link, useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

interface ConsumerHomeLinkProps {
  children: ReactNode;
  className?: string;
  "aria-label"?: string;
}

function ConsumerHomeLink(props: ConsumerHomeLinkProps) {
  const navigate = useNavigate();

  return (
    <Link
      {...props}
      to="/"
      onKeyDown={(event) => {
        if (
          event.key !== "Enter" ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }
        event.preventDefault();
        void navigate({ to: "/", viewTransition: false });
      }}
      onClick={(event) => {
        if (
          event.detail !== 0 ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }
        event.preventDefault();
        void navigate({ to: "/", viewTransition: false });
      }}
    />
  );
}

export { ConsumerHomeLink };
